import { render, staticRenderFns } from "./HealthDayPanel.vue?vue&type=template&id=b6fb141e&"
import script from "./HealthDayPanel.vue?vue&type=script&lang=ts&"
export * from "./HealthDayPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports